<template>
  <div>
    <div class="ui grid px-gen m-0 py-1">
      <div class="wide column px-gen">
        <div class="pt-2">
          <h3
            class="ui dividing header fdinpro default-header-green is-uppercase"
          >
            {{ $t("bundle addstore") }}
          </h3>
        </div>
      </div>
    </div>
    <div class="ui grid px-gen m-0 py-1">
      <div class="wide column px-gen">
        <div class="pt-2">
          <table class="ui very basic compact table">
            <tbody>
              <tr>
                <th>Bundle</th>
                <th>Tiendas</th>
                <th>{{ $t("save") }}</th>
              </tr>
              <tr v-for="(bundle, bidx) in active_bundles" :key="bidx">
                <td class="five wide">
                  {{ bundle.setup.name }}
                </td>
                <td class="five center aligned">
                  <div class="field py-1">
                    <div
                      class="ui fluid multiple search selection dropdown"
                      ref="stores_dropdown"
                      :data-stores="bundle.setup.stores"
                      :data-bundle="bundle.bundle_id"
                    >
                      <input type="hidden" name="stores" />
                      <i class="dropdown icon"></i>
                      <div class="default text">{{ $t("select stores") }}</div>
                      <div class="menu"></div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="ui blue icon button" @click="save(bidx)">
                    <i class="save icon"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast /* success_toast */ } from "@/utils";

export default {
  name: "NworkfoceNvidiaBundleManage",
  data() {
    return {
      active_bundles: [],
      stores: [],
    };
  },
  methods: {
    getBundleList(store_list) {
      let vm = this;
      local_api(
        vm,
        "post",
        "/nworkforce_nvidia/do-get-active-bundle-admin-list",
      )
        .then((list) => {
          vm.active_bundles = list;

          setTimeout(() => {
            vm.$refs.stores_dropdown.map((dds) => {
              let $dds = window.jQuery(dds);
              let ddsStores = String($dds.data("stores")) || "";
              //   let ddsBundle = String($dds.data("bundle")) || "";
              let strs = ddsStores.split(",").filter((i) => i);

              let vls = store_list
                .map((l) => {
                  return { name: l.setup.name, value: l.store_id, store: l };
                })
                .filter((p) => {
                  let managerUsers = p.store.setup.manager_users.split(",");
                  let currentUser = vm.$session.get("user").user_id;

                  let trgt = managerUsers.find((u) => {
                    return String(u) == String(currentUser);
                  });
                  if (trgt) return true;
                  else return false;
                });

              $dds.dropdown("setup menu", { values: vls }).dropdown({
                onChange(/* value */) {
                  // console.log(value);
                },
              });

              $dds.dropdown("set selected", strs);
            });
          }, 0);
        })
        .catch((error) => {
          error_toast(error);
        });
    },
    getStoreList() {
      let vm = this;
      return new Promise(function (resolve, reject) {
        local_api(vm, "post", "/nvidia_bundle/store/do-get-list")
          .then((list) => {
            vm.stores = list;

            resolve(list);
          })
          .catch((error) => {
            error_toast(error);
            reject(error);
          });
      });
    },
    save(bundle_index) {
      let vm = this;
      let trgtBundle = vm.active_bundles[bundle_index];
      let value = window
        .jQuery(vm.$refs.stores_dropdown[bundle_index])
        .dropdown("get value");

      let managerStores = vm.stores
        .filter((p) => {
          let managerUsers = p.setup.manager_users.split(",");
          let currentUser = vm.$session.get("user").user_id;

          let trgt = managerUsers.find((u) => {
            return String(u) == String(currentUser);
          });
          if (trgt) return true;
          else return false;
        })
        .map((s) => {
          return s.store_id;
        });

      //   let trgtBundle = vm.active_bundles.find((b) => {
      //     return b.bundle_id == ddsBundle;
      //   });

      let bstores = trgtBundle.setup.stores.split(",").filter((i) => i);
      let filtStores = bstores.filter((s) => {
        let isInStore = managerStores.find((m) => {
          return String(m) == String(s);
        });
        return isInStore ? false : true;
      });

      let newvls = value.split(",").filter((i) => i);
      let all = newvls.concat(filtStores);

      let allstores = all.join(",");

      local_api(vm, "post", "/nworkforce_store/do-update-bundle-stores", {
        s: allstores,
        b: trgtBundle.bundle_id,
      })
        .then(() => {
          //   success_toast(vm.$t("stores updated"));
        })
        .catch((error) => {
          error_toast(error);
        });
    },
  },
  mounted() {
    let vm = this;
    vm.getStoreList()
      .then((rr) => {
        vm.getBundleList(rr);
      })
      .catch((error) => {
        console.error(error);
      });
  },
};
</script>

<style scoped>
/* @import url("https://nworkforce.com/librerias/css/fonts/fonts.css"); */

/*  SPACING   */
.m-0 {
  margin: 0 !important;
}
.my-0 {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
.px-gen {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}
.pb-05 {
  padding-bottom: 0.5rem !important;
}
.pl-0 {
  padding-left: 0 !important;
}
.py-1 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

/*  FONTS   */
.has-text-centered {
  text-align: center !important;
}
.has-text-left {
  text-align: left !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.fdinpro {
  font-family: "DINPro" !important;
}

.default-header-green {
  border-bottom: 2pt solid #365a0c !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.testigos div p {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
  margin-bottom: 0;
}
.testigos div .grid {
  align-items: center !important;
  background-color: #ebebec !important;
}
.sb-tienda {
  display: flex !important;
  flex-direction: row;
  text-align: left !important;
}
.pre-sb-tienda {
  flex: 20%;
}
.name-sb-tienda {
  flex: 80%;
}
</style>
